<template>
  <div>
    <h2 class="subtitulo">CURSOS INSCRITOS</h2>
    <hr />
    <b-alert v-if="misCursos.length <= 0" variant="warning" dismissible show>
      Por el momento no te has registrado a ofertas en SIFC, aqui aparecerán las
      ofertas a las que te has registrado.
    </b-alert>
    <b-alert variant="warning" dismissible show>
      Por el momento sólo se pueden descargar constancias de cursos del año 2025 en adelante.
    </b-alert>
    <div>
      <b-card-group columns>
        <b-card v-for="curso in misCursos" :key="curso.id_oferta" :title="curso.nombre_curso" :img-src="
          //url + '/backassets/logos/' + curso.img
          //'../../..' + '/logos/' + curso.img
          'https://sifc3.iea.edu.mx/logos/' + curso.img
          " :sub-title="curso.institucion_formadora" img-alt="Image" img-top img-height="auto" img-width="auto"
          tag="article" class="stCard cartaInfo">
          <b-card-text>
            {{ curso.descripcion }}
            {{ curso.descripcion_det }}
            <div><strong>Resultado: </strong>{{ curso.resultado }}</div>
            <button class="btn bg-2" @click="generarConstancia(curso)" v-if="curso.resultado == 'CONCLUIDO' && curso.anio>=2025 ">Descargar
              Constancia</button>
          </b-card-text>
          <!--<b-button href="#" variant="success">Registrarme</b-button>-->
        </b-card>
      </b-card-group>
    </div>

  </div>
</template>

<script>
//import axios from "axios";
import { queryIEASIS } from "../backIeasis/dbContextConexion";
import { alert } from "@/assets/functions";
//import { getRegistroFormacionById } from "../backIeasis/registro.js";
import { getBase64ImageFromURL } from "../backIeasis/base64encode.js";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
//import axios from "axios";

//GENERACIÓN DE CONSTANCIAS

import imagen from '../../../public/logos/Constancia_2025.png'

  //FIRMA 2025
import firma1 from '../../../public/logos/firm22.png'
import firma2 from '../../../public/logos/firm21.png'

//FIRMA 2026
import firm2026 from '../../../public/logos/firm2026.png'



//import imginstancia from '../../../public/logos/854f5989a30b0dc9492e6c8e98967eaf.png'



pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "MiFormacionComponent",
  data() {
    return {
      misCursos: [],
   
      misCursos2: [],
      usuario: sessionStorage.getItem("usuario"),

      url: process.env.VUE_APP_URL,

      filtro: "",
      
      
      //BANDERAJE PARA SOLO CONSTANCIAS 2025
      fechaje: null,

      buscando: false,
      registros: [],
      registrosSelected: [],
      modalRegistroUsuario: false,
      fields: [
        { key: "CURP", sortable: true },
        { key: "nombre_completo", sortable: true },
        "nombre_oferta",
        "grupo",
        "periodoFC",
        "resultado",
        { key: "_id" },
      ],     

    };
  },
  mounted() {
    this.getMisCursos();

  },
  methods: {

    async getMisCursos() {


      //QUERY PARA VISTA
      /*
      const query = "select a.idusuario, a.id_oferta, a.resultado, b.id_oferta, b.descripcion, b.descripcion_det, b.nombre_curso, c.institucion_formadora, c.idinstitucion, c.img, a.historico, year(b.fecha_ini) as anio from registros a" +
        " INNER JOIN oferta_formacion b ON a.id_oferta =  b.id_oferta" +
        " INNER JOIN instituciones_formadoras c ON b.institucion_formadora = c.idinstitucion" +
        " where idusuario = " + sessionStorage.getItem("id") + " order by anio desc"
      */
      const query = "select a.idusuario, a.id_oferta, a.resultado, b.id_oferta, b.descripcion, b.descripcion_det, b.nombre_curso, c.institucion_formadora, c.idinstitucion, c.img, a.historico, year(b.fecha_ini) as anio from registros a INNER JOIN usuarios u ON u.idusuario = a.idusuario INNER JOIN oferta_formacion b ON a.id_oferta =  b.id_oferta INNER JOIN instituciones_formadoras c ON b.institucion_formadora = c.idinstitucion where u.email in (select email from usuarios" +
      " where idusuario = " + sessionStorage.getItem("id") + " )" +
      " order by anio desc"
      const res = await queryIEASIS(query)
      

      if (res) {
        console.log('QUERY DE VISTA:', res);
        this.misCursos = res;
        console.clear();
      }
     
    },


    selectTodo() {
      this.$refs.tablaRegistros.selectAllRows();
    },
    clearSelect() {
      this.$refs.tablaRegistros.clearSelected();
    },
    onSelected(items) {
      this.registrosSelected = items;
      console.log(items);
    },
    editar(registro) {
      console.log("Registro", registro);
      this.registroSelected = registro;
      //this.modalRegistroUsuario = true;
    },

    async generarConstancia(curso) {
      if(curso.id_oferta == 388 || curso.id_oferta == 389 ){
        curso.anio == 2026
        console.log('nueva entrada')
      }
      console.log(curso)
      console.log('curso.historico:', curso.historico)
      console.log('this.miscursos2: ', this.misCursos2)

      
      if(curso.anio >= 2025){
        console.log('es del año 2025 o sup.')
        alert('DESCARGANDO CONSTANCIA', 'success')}
        else if (curso.anio <=2024){
          alert('POR EL MOMENTO, SÓLO SE PUEDEN DESCARGAR CONSTANCIAS DEL 2025 O AÑOS POSTERIORES', 'danger')
          return;
        }

        if(curso.anio ==2026){
          console.log('prueba')
        }
      
        
      if (curso.historico == 1){
      //QUERY HISTORICO (BOTÓN GEN CONSTANCIA)

        const query2 = "select TOP 1 r.idregistro, r.id_oferta, o.nombre_curso, o.descripcion,o.descripcion_det, o.fecha_ini, o.fecha_fin, ofe.nombre as Oferta, td.horas, f.institucion_formadora, f.img, r.resultado, r.idusuario, u.usuario, u.nombres, u.apellidop, u .apellidom from registros r INNER JOIN usuarios u ON r.idusuario = u.idusuario INNER JOIN oferta_formacion o ON r.id_oferta = o.id_oferta INNER JOIN instituciones_formadoras f ON o.institucion_formadora = f.idinstitucion INNER JOIN tipos_oferta_det td ON td.idofertadet = o.tipo_oferta INNER JOIN tipos_oferta ofe ON ofe.idoferta = td.idoferta where u.email in (select email from usuarios " +
        " where idusuario = " + sessionStorage.getItem("id") + " )" +
        " and r.id_oferta = " + curso.id_oferta + " AND r.historico=1 "


      const res2 = await queryIEASIS(query2)
      console.log(res2)
      //VACIO DE VARIABLES RESPOONSE A OBJETO curso
      //curso.idregistro = (res2[0].idregistro)
        curso= res2[0]
      

      }

      if(curso.historico == 0){    
      const query3 = 
      "select r.idregistro, r.id_oferta, o.nombre_curso, o.descripcion,o.descripcion_det, o.fecha_ini, o.fecha_fin, ofe.nombre as Oferta, od.horas, f.institucion_formadora, f.img, r.resultado, r.idusuario, u.usuario, u.nombres, u.apellidop, u .apellidom from registros r INNER JOIN usuarios u ON r.idusuario = u.idusuario INNER JOIN oferta_formacion o ON r.id_oferta = o.id_oferta INNER JOIN instituciones_formadoras f ON o.institucion_formadora = f.idinstitucion INNER JOIN tipos_oferta_det td ON td.idofertadet = o.tipo_oferta INNER JOIN tipos_oferta ofe ON ofe.idoferta = td.idoferta INNER JOIN tipos_oferta_det od ON  od.idofertadet = o.tipo_oferta " +
      "where u.idusuario= " + sessionStorage.getItem("id") + " and r.id_oferta = " + curso.id_oferta + " AND r.historico=0"

      const res3 = await queryIEASIS(query3)
      console.log(res3)
      //VACIO DE VARIABLES RESPOONSE A OBJETO curso
      //curso.idregistro = (res2[0].idregistro)
      curso= res3[0]
    

      }

     


      //OBTENER IMAGEN BASE64 DE CONSTANCIA
      const imgImport = imagen
      const imgBase64 = await getBase64ImageFromURL(imgImport);
      //console.log("Path: " + imgBase64);

      const firma1Import = firma1
      const firma2Import = firma2
      
      //Firma 2026
      const firma3Import = firm2026

      const firma1Base64 = await getBase64ImageFromURL(firma1Import);
      const firma2Base64 = await getBase64ImageFromURL(firma2Import);
      const firma3Base64 = await getBase64ImageFromURL(firma3Import);

      const imginstancia = "https://sifc3.iea.edu.mx/logos/" + curso.img
      //const imginstancia = "http://localhost:8080/logos/" + curso.img
      const instancia = await getBase64ImageFromURL(imginstancia);

      //OBTENER FIRMA DIGITAL
      //const cadenaOriginal = curso.nombres +"|"+ curso.apellidop +"|"+ curso.apellidom +"|"+ curso.Oferta +"|"+ 
      // curso.nombre_curso +"|"+ curso.resultado +"|"+ curso.fecha_fin +"|"+ curso.idregistro;

      //const firma = await obtenerFirmantes(cadenaOriginal);


      //CONSTANCIA 2025 Y ANTERIORES
      if ( curso.fecha_ini.includes("2025") && curso.id_oferta != 388 && curso.id_oferta != 389 ){

    
      console.log('entro aqui,',curso)
      const constanciaDef = {
        pageSize: "LETTER",
        watermark: {
          // text: 'DOCUMENTO DE PRUEBA'
        },
        layout: "noBorders",
        background: [
          {
            image: imgBase64,
            width: 616,
            height: 856,
          },
        ],
        content: [],
        styles: {
          iea: {
            fontSize: 20,
            color: "#181c52",
            alignment: "center",
            bold: false,
            italics: false,
          },
          leyenda: {
            fontSize: 14,
            color: "#8A8A8A",
            alignment: "center",
            bold: false,
            italics: false,
          },
          leyenda1: {
            fontSize: 14,
            color: "#181c52",
            alignment: "center",
            bold: false,
            italics: false,
          },
          nombre: {
            fontSize: 22,
            alignment: "center",
            color: "#2BADC3",
            bold: true,
            italics: true,
          },
          firma: {
            fontSize: 11,
            color: "#181c52",
            bold: false,
            italics: false,
            alignment: "center",
          },
          folio: {
            fontSize: 8,
            color: "#181c52",
            bold: false,
            italics: false,
            alignment: "center",
          },
          firmaBold: {
            fontSize: 11,
            color: "#181c52",
            bold: true,
            italics: false,
            alignment: "center",
          },
          selloDigital: {
            fontSize: 8,
            color: "#181c52",
            bold: true,
            italics: false,
            alignment: "left",
          },
        },
      };
      constanciaDef.content.push([
        {
          table: {
            heights: [20],
            widths: [520],
            body: [

              [
                {
                  text: ".",
                },
              ],
              [
                {
                  text: ".",
                },
              ],

            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [10, 10],
            widths: [30, 400, 100],
            body: [
              [
                [

                ],
                [
                  {
                    qr: `https://sifc3.iea.edu.mx/#/validar?id=${curso.idregistro}`,
                   // qr: `http://localhost:8080/#/validar?id=${curso.idregistro}`,
                    fit: "85"//"90",
                  },
                ],
                [
                  {
                    // tslint:disable-next-line: max-line-length
                    //text: "-01-IEA-DCM-2025-" + curso.idregistro + "",
                    image: instancia,
                    //style: "firma",
                    fit: [120,60],
                  },
                ],
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [20],
            widths: [130],
            body: [

              [
                 [
                  {
                    // tslint:disable-next-line: max-line-length
                    text: "-01-IEA-DCM-2025-" + curso.idregistro + "\n Registro 2025",
                    
                    style: "folio",
                  },
                ]
              ],

            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [20],
            widths: [520],
            body: [
              [
                {
                  // tslint:disable-next-line: max-line-length
                  text: "El Instituto de Educación de Aguascalientes, a través de la \nDirección de Carrera del Magisterio, otorga la presente\n\n\n",
                  style: "leyenda",
                },
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [55, 20, 20, 30, 40, 30],
            widths: [520],
            body: [
              [
                {
                  text: "", //EL INSTITUTO DE EDUCACIÓN \nDE AGUASCALIENTES\n\n
                  style: "iea",
                },
              ],
              [
                {
                  text: "A: " + curso.nombres + " " + curso.apellidop + " " + curso.apellidom + "\n\n",
                  style: "nombre",
                },
              ],
              [
                {
                  text: "",
                },
              ],
              [
                {
                  text: `Por su participación en ${curso.Oferta}:`,
                  style: "leyenda",
                },
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [160],
            widths: [10, 500, 10],
            body: [
              [
                [""], //Celda vacía
                [{
                  // tslint:disable-next-line: max-line-length
                  text: `${curso.nombre_curso}\nCon una duración de ${curso.horas
                    } horas, impartido en el periodo ${moment(
                      curso.fecha_ini
                    )
                      .locale("es")
                      .utc()
                      .format("LL")} al ${moment(curso.fecha_fin)
                        .locale("es")
                        .utc()
                        .format(
                          "LL"
                        )}, correspondiente a las Acciones de Formación Continua, Actualización y Desarrollo Profesional en la Educación Básica\n2025.`,
                  style: "leyenda1",
                },],
                [""] //Celda vacía
              ]
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [50, 50],
            widths: [30, 240, 10, 260],
            body: [
              [
                [],
                [
                  {
                    //text: `\n\n\n\nDra. Gabriela Rocha Colis`,
                    //style: "firmaBold",
                    image: firma2Base64,
                    width: 220,
                  },
                ],
                [],
                [
                  {
                    //text: `\n\n\n\nMtra. Leticia Torres Soto`,
                    //style: "firmaBold",
                    image: firma1Base64,
                    width: 220,
                  },
                ],
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [1],
            widths: [260, 260],
            body: [
              [
                [
                  /*{
                    //text: `\n\n\n\nDra. Gabriela Rocha Colis`,
                    //style: "firmaBold",
                    image: firma2Base64,
                    width: 290,
                  },*/
                  {
                    text: `Dra. Gabriela Rocha Colis`,
                    style: "firmaBold",
                  },
                  {
                    // tslint:disable-next-line: max-line-length
                    text: `Directora de Carrera del Magisterio`,
                    style: "firma",
                  },
                ],
                [
                  /*{
                    //text: `\n\n\n\nDra. Gabriela Rocha Colis`,
                    //style: "firmaBold",
                    image: firma1Base64,
                    width: 290,
                  },*/
                  {
                    text: `Mtra. Leticia Torres Soto`,
                    style: "firmaBold",
                  },
                  {
                    // tslint:disable-next-line: max-line-length
                    text: `Subdirectora de Mejora Continua del Magisterio`,
                    style: "firma",
                  },
                ],
              ],
            ],
          },
          layout: "noBorders",
        },



      ]);

      pdfMake.createPdf(constanciaDef).download('CONSTANCIA.pdf');
          
      } //endif

      //GENERACIÓN DE CONSTANCIA INTERMEDIA 2025-2026
     
      if (curso.id_oferta == 388 || curso.id_oferta == 389 ){
    
      console.log('¡Constancia 25-26!,',curso)
      const constanciaDef = {
        pageSize: "LETTER",
        watermark: {
          // text: 'DOCUMENTO DE PRUEBA'
        },
        layout: "noBorders",
        background: [
          {
            image: imgBase64,
            width: 616,
            height: 856,
          },
        ],
        content: [],
        styles: {
          iea: {
            fontSize: 20,
            color: "#181c52",
            alignment: "center",
            bold: false,
            italics: false,
          },
          leyenda: {
            fontSize: 14,
            color: "#8A8A8A",
            alignment: "center",
            bold: false,
            italics: false,
          },
          leyenda1: {
            fontSize: 14,
            color: "#181c52",
            alignment: "center",
            bold: false,
            italics: false,
          },
          nombre: {
            fontSize: 22,
            alignment: "center",
            color: "#2BADC3",
            bold: true,
            italics: true,
          },
          firma: {
            fontSize: 11,
            color: "#181c52",
            bold: false,
            italics: false,
            alignment: "center",
          },
          folio: {
            fontSize: 8,
            color: "#181c52",
            bold: false,
            italics: false,
            alignment: "center",
          },
          firmaBold: {
            fontSize: 11,
            color: "#181c52",
            bold: true,
            italics: false,
            alignment: "center",
          },
          selloDigital: {
            fontSize: 8,
            color: "#181c52",
            bold: true,
            italics: false,
            alignment: "left",
          },
        },
      };
      constanciaDef.content.push([
        {
          table: {
            heights: [20],
            widths: [520],
            body: [

              [
                {
                  text: ".",
                },
              ],
              [
                {
                  text: ".",
                },
              ],

            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [10, 10],
            widths: [30, 400, 100],
            body: [
              [
                [

                ],
                [
                  {
                    qr: `https://sifc3.iea.edu.mx/#/validar?id=${curso.idregistro}`,
                   // qr: `http://localhost:8080/#/validar?id=${curso.idregistro}`,
                    fit: "85"//"90",
                  },
                ],
                [
                  {
                    // tslint:disable-next-line: max-line-length
                    //text: "-01-IEA-DCM-2025-" + curso.idregistro + "",
                    image: instancia,
                    //style: "firma",
                    fit: [120,60],
                  },
                ],
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [20],
            widths: [130],
            body: [

              [
                 [
                  {
                    // tslint:disable-next-line: max-line-length
                    text: "-01-IEA-DCM-2025-" + curso.idregistro + "\n Registro 2025",
                    
                    style: "folio",
                  },
                ]
              ],

            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [20],
            widths: [520],
            body: [
              [
                {
                  // tslint:disable-next-line: max-line-length
                  text: "El Instituto de Educación de Aguascalientes, a través de la \nDirección de Carrera del Magisterio, otorga la presente\n\n\n",
                  style: "leyenda",
                },
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [55, 20, 20, 30, 40, 30],
            widths: [520],
            body: [
              [
                {
                  text: "", //EL INSTITUTO DE EDUCACIÓN \nDE AGUASCALIENTES\n\n
                  style: "iea",
                },
              ],
              [
                {
                  text: "A: " + curso.nombres + " " + curso.apellidop + " " + curso.apellidom + "\n\n",
                  style: "nombre",
                },
              ],
              [
                {
                  text: "",
                },
              ],
              [
                {
                  text: `Por su participación en ${curso.Oferta}:`,
                  style: "leyenda",
                },
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [160],
            widths: [10, 500, 10],
            body: [
              [
                [""], //Celda vacía
                [{
                  // tslint:disable-next-line: max-line-length
                  text: `${curso.nombre_curso}\nCon una duración de ${curso.horas
                    } horas, impartido en el periodo ${moment(
                      curso.fecha_ini
                    )
                      .locale("es")
                      .utc()
                      .format("LL")} al ${moment(curso.fecha_fin)
                        .locale("es")
                        .utc()
                        .format(
                          "LL"
                        )}, correspondiente a las Acciones de Formación Continua, Actualización y Desarrollo Profesional en la Educación Básica\n2025.`,
                  style: "leyenda1",
                },],
                [""] //Celda vacía
              ]
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [50, 50],
            widths: [30, 240, 10, 260],
            body: [
              [
                [],
                [
                  {
                     //text: `\n\n\n\nDra. Olivia González Segovia`,
                    //style: "firmaBold",
                    image: firma3Base64,
                    width: 220,
                  },
                ],
                [],
                [
                  {
                    //text: `\n\n\n\nMtra. Leticia Torres Soto`,
                    //style: "firmaBold",
                    image: firma1Base64,
                    width: 220,
                  },
                ],
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [1],
            widths: [260, 260],
            body: [
              [
                [
                  /*{
                    //text: `\n\n\n\nDra. Gabriela Rocha Colis`,
                    //style: "firmaBold",
                    image: firma2Base64,
                    width: 290,
                  },*/
                  {
                    text: `Dra. Olivia González Segovia`,
                    style: "firmaBold",
                  },
                  {
                    // tslint:disable-next-line: max-line-length
                    text: `Directora de Carrera del Magisterio`,
                    style: "firma",
                  },
                ],
                [
                  /*{
                    //text: `\n\n\n\nDra. Gabriela Rocha Colis`,
                    //style: "firmaBold",
                    image: firma1Base64,
                    width: 290,
                  },*/
                  {
                    text: `Mtra. Leticia Torres Soto`,
                    style: "firmaBold",
                  },
                  {
                    // tslint:disable-next-line: max-line-length
                    text: `Subdirectora de Mejora Continua del Magisterio`,
                    style: "firma",
                  },
                ],
              ],
            ],
          },
          layout: "noBorders",
        },



      ]);
      console.log('Se generó una constancia 2025-2026')
      pdfMake.createPdf(constanciaDef).download('CONSTANCIA.pdf');
      
          
      } //endif




      //GENERACIÓN DE CONSTANCIA 2026 ->
      if(curso.fecha_ini.includes("2026") && curso.id_oferta != 388 && curso.id_oferta != 389) {
      
      //|| curso.id_oferta==389 || curso.id_oferta==388) {  //curso.id_oferta == 389)){     
         
      const constanciaDef2 = {
        pageSize: "LETTER",
        watermark: {
          // text: 'DOCUMENTO DE PRUEBA'
        },
        layout: "noBorders",
        background: [
          {
            image: imgBase64,
            width: 616,
            height: 856,
          },
        ],
        content: [],
        styles: {
          iea: {
            fontSize: 20,
            color: "#181c52",
            alignment: "center",
            bold: false,
            italics: false,
          },
          leyenda: {
            fontSize: 14,
            color: "#8A8A8A",
            alignment: "center",
            bold: false,
            italics: false,
          },
          leyenda1: {
            fontSize: 14,
            color: "#181c52",
            alignment: "center",
            bold: false,
            italics: false,
          },
          nombre: {
            fontSize: 22,
            alignment: "center",
            color: "#2BADC3",
            bold: true,
            italics: true,
          },
          firma: {
            fontSize: 11,
            color: "#181c52",
            bold: false,
            italics: false,
            alignment: "center",
          },
          folio: {
            fontSize: 8,
            color: "#181c52",
            bold: false,
            italics: false,
            alignment: "center",
          },
          firmaBold: {
            fontSize: 11,
            color: "#181c52",
            bold: true,
            italics: false,
            alignment: "center",
          },
          selloDigital: {
            fontSize: 8,
            color: "#181c52",
            bold: true,
            italics: false,
            alignment: "left",
          },
        },
      };
      constanciaDef2.content.push([
        {
          table: {
            heights: [20],
            widths: [520],
            body: [

              [
                {
                  text: ".",
                },
              ],
              [
                {
                  text: ".",
                },
              ],

            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [10, 10],
            widths: [30, 400, 100],
            body: [
              [
                [

                ],
                [
                  {
                    qr: `https://sifc3.iea.edu.mx/#/validar?id=${curso.idregistro}`,
                   // qr: `http://localhost:8080/#/validar?id=${curso.idregistro}`,
                    fit: "85"//"90",
                  },
                ],
                [
                  {
                    // tslint:disable-next-line: max-line-length
                    //text: "-01-IEA-DCM-2025-" + curso.idregistro + "",
                    image: instancia,
                    //style: "firma",
                    fit: [120,60],
                  },
                ],
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [20],
            widths: [130],
            body: [

              [
                 [
                  {
                    // tslint:disable-next-line: max-line-length
                    text: "-01-IEA-DCM-2026-" + curso.idregistro + "\n Registro 2026",
                    
                    style: "folio",
                  },
                ]
              ],

            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [20],
            widths: [520],
            body: [
              [
                {
                  // tslint:disable-next-line: max-line-length
                  text: "El Instituto de Educación de Aguascalientes, a través de la \nDirección de Carrera del Magisterio, otorga la presente\n\n\n",
                  style: "leyenda",
                },
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [55, 20, 20, 30, 40, 30],
            widths: [520],
            body: [
              [
                {
                  text: "", //EL INSTITUTO DE EDUCACIÓN \nDE AGUASCALIENTES\n\n
                  style: "iea",
                },
              ],
              [
                {
                  text: "A: " + curso.nombres + " " + curso.apellidop + " " + curso.apellidom + "\n\n",
                  style: "nombre",
                },
              ],
              [
                {
                  text: "",
                },
              ],
              [
                {
                  text: `Por su participación en ${curso.Oferta}:`,
                  style: "leyenda",
                },
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [160],
            widths: [10, 500, 10],
            body: [
              [
                [""], //Celda vacía
                [{
                  // tslint:disable-next-line: max-line-length
                  text: `${curso.nombre_curso}\nCon una duración de ${curso.horas
                    } horas, impartido en el periodo ${moment(
                      curso.fecha_ini
                    )
                      .locale("es")
                      .utc()
                      .format("LL")} al ${moment(curso.fecha_fin)
                        .locale("es")
                        .utc()
                        .format(
                          "LL"
                        )}, correspondiente a las Acciones de Formación Continua, Actualización y Desarrollo Profesional en la Educación Básica\n2026.`,
                  style: "leyenda1",
                },],
                [""] //Celda vacía
              ]
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [50, 50],
            widths: [30, 240, 10, 260],
            body: [
              [
                [],
                [
                  {
                    //text: `\n\n\n\nDra. Olivia González Segovia`,
                    //style: "firmaBold",
                    image: firma3Base64,
                    width: 220,
                  },
                ],
                [],
                [
                  {
                    //text: `\n\n\n\nMtra. Leticia Torres Soto`,
                    //style: "firmaBold",
                    image: firma1Base64,
                    width: 220,
                  },
                ],
              ],
            ],
          },
          layout: "noBorders",
        },
        {
          table: {
            heights: [1],
            widths: [260, 260],
            body: [
              [
                [
                  /*{
                    //text: `\n\n\n\nDra. Gabriela Rocha Colis`,
                    //style: "firmaBold",
                    image: firma2Base64,
                    width: 290,
                  },*/
                  {
                    text: `Dra. Olivia González Segovia`,
                    style: "firmaBold",
                  },
                  {
                    // tslint:disable-next-line: max-line-length
                    text: `Directora de Carrera del Magisterio`,
                    style: "firma",
                  },
                ],
                [
                  /*{
                    //text: `\n\n\n\nDra. Gabriela Rocha Colis`,
                    //style: "firmaBold",
                    image: firma1Base64,
                    width: 290,
                  },*/
                  {
                    text: `Mtra. Leticia Torres Soto`,
                    style: "firmaBold",
                  },
                  {
                    // tslint:disable-next-line: max-line-length
                    text: `Subdirectora de Mejora Continua del Magisterio`,
                    style: "firma",
                  },
                ],
              ],
            ],
          },
          layout: "noBorders",
        },



      ]);
      console.log('Generó una constancia 2026')
      pdfMake.createPdf(constanciaDef2).download('CONSTANCIA.pdf');
      }


      //GENERAR LOG DE REGISTRO
      const today = new Date().toISOString().slice(0, 10);
      const query4 = "INSERT INTO logs (id_usuario, fecha) VALUES (" + sessionStorage.getItem("id") + " , ' " + today + " ')"
      const res4 = await queryIEASIS(query4)
      console.log(res4)



      /*pdfMake.createPdf({
        content: [
          'Hello World From PDFMake!' + curso.nombre_curso,

          
        ]
      }).download('PRUEBA1.pdf');*/
    },

  },
};
</script>